<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
        <v-btn flat slot="activator"><v-icon left>lock_open</v-icon>Permissions</v-btn>
        <v-card>
            <form v-on:submit.prevent="create">
                <v-card-title>
                    <span class="headline">Permissions:</span>
                </v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-checkbox v-model="data.permissions" label="Orders confirmations" value="Orders"></v-checkbox>
                        <v-checkbox v-model="data.permissions" label="Sample requests" value="Sample Orders"></v-checkbox>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { DICCIONARIO } from '../../../../diccionario';

    export default {
        props: ['id', 'contact'],
        data: () => ({
            dialog: false,
            data : {},
        }),
        created () {
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        watch: {
            dialog: function(dialog) {
                this.data = Object.assign({}, this.contact);
                var permisos = this.data.permissions;
                this.data.permissions = [];
                for (var i = 0; i < permisos.length; i++) {
                    this.data.permissions.push(permisos[i].name);
                }
            }
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$emit('guardar', this.data);
                        this.dialog = false;
                    }
                });
            },
            cancel () {
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/clients/components/PermisosContactModal.vue